<div class="breadcrumb-container">
  <div class="breadcrumb-wrapper">
    <a [routerLink]="['/home']" class="breadcrumb-link">Home</a>
    <img src="assets/icons/chevron-right.svg" alt="chevron-right" />
    <a
      [routerLink]="breadcrumbItems.currentPageLink"
      class="breadcrumb-active-link"
      >{{ breadcrumbItems.currentPage }}</a
    >
  </div>
</div>
